import React, { useEffect, useState } from "react";
import "./selectFromLibr.css";
import axios from "../../../../axios";
import Form from "react-bootstrap/Form";
import LibraryPropsBox from "./Select_Library_Box/LibraryPropsBox";
import OpenLibraryPage from "./Select_Library_Box/OpenLibraryPage";

const SelectFromLibr = ({ setClick1, setQuestions, assessmentDetails, questions, getquestiondata, sourceLibrary }) => {
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(localStorage.getItem('timeTableSessionId'))
  const [click, setClick] = useState(false);
  const [selQueID, setSelQueID] = useState([]);
  const [filter, setFilter] = useState({
    standard: assessmentDetails?.standard_id,
    section: assessmentDetails?.section_id,
    subject: assessmentDetails?.subject_id,
    skill: null,
    domain: null,
    bookChapter: null,
    difficultyLevel: null,
    limit: Infinity,
    page: 1,
    name: assessmentDetails.name,
  });
  const [selectedQuestion, setSelectedQuestion] = useState([]);
  const [libraryQuestions, setLibraryQuestions] = useState([]);
  const [dropdownList, setDropdownList] = useState({
    skills: null,
    types: null,
    domains: null,
    chapters: null,
    difficultyLevels: null,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;
  useEffect(() => {
    try {
      const getDetails = async () => {
        let skills = await axios.get(`/api/v1/school/skill/get`);
        skills &&
          setDropdownList((prev) => ({ ...prev, skills: skills.data.data }));

        let chapters = await axios.get(
          //TBD:New book info url integration
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`
          // `/api/v1/school/book/get/standardId/${assessmentDetails?.standard_id?.id}?sectionId=${assessmentDetails?.section_id?.id}&subjectId=${assessmentDetails?.subject_id?.id}&isWithChapters=true`
        );
        // console.log(chapters)
        chapters &&
          setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));

        let domains = await axios.get(`/api/v1/school/domain/get`);
        domains &&
          setDropdownList((prev) => ({ ...prev, domains: domains.data.data }));

        let types = await axios.get(
          `/api/v1/questionType/get/school/${school_id}`
        );
        types && setDropdownList((prev) => ({ ...prev, types: types.data.data }));

        let difficultyLevels = await axios.get(`/api/v1/difficultyLevel/get`);
        difficultyLevels &&
          setDropdownList((prev) => ({
            ...prev,
            difficultyLevels: difficultyLevels.data.data,
          }));
      };
      getDetails();
    } catch (error) {
      console.log(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!click && (
        <div className="library_transprant_body">
          <div className="p-4 library_container">
            <img
              src="/images/cross-circle3.svg"
              className="library_close_btn_hw"
              alt=""
              onClick={(e) => {
                setClick1(false);
                for (const que of selQueID) {
                  localStorage.removeItem(`isChecked_${que}`);
                }
              }}
            />
            <div className="d-flex justify-content-between">
              <span className="select_library_header">Select From Library</span>
              <span className="library_selected_count">
                Selected ({selectedQuestion.length})
              </span>
            </div>

            <div className="d-flex gap-3 mt-4">
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">STANDARD</div>
                <span className=" hw_default_dropdown_box_size">
                  {assessmentDetails?.standard_id?.name}
                </span>
              </div>

              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">SECTION</div>
                <span className=" hw_default_dropdown_box_size">
                  {assessmentDetails?.section_id?.name}
                </span>
              </div>

              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">SUBJECT</div>
                <span className=" hw_default_dropdown_box_size">
                  {assessmentDetails?.subject_id?.name}
                </span>
              </div>

              <div
                style={{ marginTop: "-6px" }}
                className="hw_default_dropdown_card"
              >
                <span className="hw_default_dropdown_box_header">CHAPTER</span>
                <select
                  id="bookChapterSelect"
                  className="hw_default_sub_dropdown_size form-select"
                  onChange={(e) => {
                    setLibraryQuestions([]);
                    setFilter((prev) => ({
                      ...prev,
                      bookChapter: {
                        bookId:
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "book-id"
                          ),
                        bookName:
                          e.target.options[e.target.selectedIndex].getAttribute(
                            " book-name"
                          ),
                        chapterId: e.target.value,
                        chapterName:
                          e.target.options[e.target.selectedIndex].text,
                      },
                      page: 1,
                    }));
                  }}
                  value={filter?.bookChapter?.chapterId}
                >
                  <option>Select Chapter</option>
                  {chapters?.length > 0 &&
                    chapters?.map((item) =>
                      item.bookInfo.map((book) => (
                        <optgroup
                          label={book.name}
                          key={book.id}
                          book-id={book.id}
                        >
                          {book.chapterData.map((chapter) => (
                            <option
                              key={chapter.id}
                              book-id={book.id}
                              book-name={book.name}
                              value={chapter.id}
                            >
                              {chapter.chapterName}
                            </option>
                          ))}
                        </optgroup>
                      ))
                    )}
                </select>
                {/* <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
              >
                <option >Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name}
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            book-name={book.name}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    ))
                  )}
              </select> */}
              </div>
            </div>
            <div className="mt-2 d-flex gap-3 flex-wrap">
              <div style={{ flex: "3" }} className="">
                <span className="hw_default_dropdown_box_header">DOMAIN</span>
                <select
                  onChange={(e) => {
                    setLibraryQuestions([]);
                    setFilter((prev) => ({
                      ...prev,
                      domain: {
                        id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      },
                      page: 1,
                    }));
                  }}
                  size="md"
                  id="hello"
                  className="form-select hw_default_sub_dropdown_size"
                >
                  <option value="">Select Knowledge Domain</option>
                  {domains &&
                    domains.length > 0 &&
                    domains.map((domain, index) => (
                      <option key={index} value={domain?.id}>
                        {domain?.name}
                      </option>
                    ))}
                </select>
              </div>

              <div style={{ flex: "3" }} className="">
                <span className="hw_default_dropdown_box_header">SKILL</span>
                <select
                  onChange={(e) => {
                    setLibraryQuestions([]);
                    setFilter((prev) => ({
                      ...prev,
                      skill: {
                        id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      },
                      page: 1,
                    }));
                  }}
                  size="md"
                  id="hello"
                  className="form-select hw_default_sub_dropdown_size"
                >
                  <option value="">Select Skill</option>
                  {skills &&
                    skills.length > 0 &&
                    skills.map((skill, index) => (
                      <option key={index} value={skill.id}>
                        {skill.name}
                      </option>
                    ))}
                </select>
              </div>

              <div style={{ flex: "3" }} className="">
                <span className="hw_default_dropdown_box_header">
                  DIFFICULTY LEVEL
                </span>
                <select
                  onChange={(e) => {
                    setLibraryQuestions([]);
                    setFilter((prev) => ({
                      ...prev,
                      difficultyLevel: {
                        id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      },
                      page: 1,
                    }));
                  }}
                  size="md"
                  className="form-select hw_default_sub_dropdown_size"
                  id="hello"
                >
                  <option value="">Select Difficulty Level</option>
                  {difficultyLevels &&
                    difficultyLevels.length > 0 &&
                    difficultyLevels.map((difficultyLevel, index) => (
                      <option key={index} value={difficultyLevel?.id}>
                        {difficultyLevel?.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div
              id="total-assessment-library-question"
              className="mt-4 p-1 hw_library_box_conatainer"
            >
              <div className="d-flex flex-wrap hw_box_gap">
                <LibraryPropsBox
                  filter={filter}
                  setFilter={setFilter}
                  libraryQuestions={libraryQuestions}
                  setLibraryQuestions={setLibraryQuestions}
                  selectedQuestion={selectedQuestion}
                  setSelectedQuestion={setSelectedQuestion}
                  setSelQueID={setSelQueID}
                  questions={questions}
                  sourceLibrary={sourceLibrary}
                  assessmentDetails={assessmentDetails}
                  getquestiondata={getquestiondata}
                />
              </div>
            </div>

            <div className="mt-4 d-flex align-items-center justify-content-end">
              <button
                className="btn library_next_btn"
                onClick={(e) => setClick(true)}
                disabled={selectedQuestion.length === 0}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      {click && (
        <OpenLibraryPage
          filter={filter}
          setClick1={setClick1}
          setQuestions={setQuestions}
          selectedQuestion={selectedQuestion}
          setClick={setClick}
          selQueID={selQueID}
          questions={questions}
        />
      )}
    </>
  );
};

export default SelectFromLibr;
